{
  // ============================================================
  // アプリケーション全体
  // ============================================================
  app: {
    copyright: "© 2026 WiseVine, Inc.",
    title: "WiseVine BnS 事業立案+AI",
    "terms-of-use": "利用規約",
    contact: "お問い合わせ",
  },

  // ============================================================
  // ホーム
  // ============================================================
  home: {
    documentTitle: {
      index: "ホーム",
    },
    navigation: {
      title: "ホーム",
    },
    announcement: {
      title: "お知らせ",
      "release-tag": "リリース",
      // 2026.05.14 リリースノート
      "release-notes-20260514-title": "「事業概要」を一括取込できるようになりました！",
      "release-notes-20260514-date": "2026年5月14日",
      "release-notes-20260514-description": "データ取込項目に「事業概要」を追加し、事業一括作成時に事業概要もまとめて反映できるようになりました。事業作成後の個別編集の手間を減らし、財源マッチングAIの判定精度向上にもつながります。",
      "release-notes-20260514-detail-link": "詳細をサポートサイトで確認する",
      // 2026.05.01 リリースノート
      "release-notes-20260501-title": "ご要望の多かった「事業一括削除」機能追加！！",
      "release-notes-20260501-date": "2026年5月1日",
      "release-notes-20260501-bulk-delete-description": "事業一覧から複数の事業を選択して、まとめて削除できるようになりました！整理作業の負担を大幅に軽減します。",
      "release-notes-20260501-detail-link": "詳細をサポートサイトで確認する",
      // 2026.04.28 リリースノート
      "release-notes-20260428-title": "事業詳細AIチャットの公開と事業・査定の管理機能の改善！！",
      "release-notes-20260428-date": "2026年4月28日",
      "release-notes-20260428-chat-title": "事業詳細チャット機能",
      "release-notes-20260428-chat-description": "事業詳細ページでAIと対話できるようになりました。施策の具体化やKPI検討など、事業の内容を踏まえた壁打ちをその場でできます。",
      "release-notes-20260428-tag-title": "タグ機能（事業タグ・査定タグ）",
      "release-notes-20260428-tag-description": "事業・査定の各項目にタグを付けて整理・絞り込みができます。",
      "release-notes-20260428-detail-link": "詳細をサポートサイトで確認する",
    },
    welcomeModal: {
      title: "事業立案＋AIへようこそ！",
      description: "事業立案＋AIは、事業の立案から予算編成・事業評価まで、自治体業務をAIがサポートするサービスです。\nまずは「スタートガイド」に沿って初期設定を進めてみましょう。",
      "open-start-guide-button": "スタートガイドを開く",
      "close-button": "閉じる",
    },
    feedback: {
      title: "ご意見・ご要望をお聞かせください",
      description: "事業立案＋AIは、現場の声をもとに機能を育てています。\n使ってみた感想・困ったこと・あったら嬉しい機能など、なんでもお気軽にお寄せください。",
      "submit-button": "意見を送る",
    },
  },

  // ============================================================
  // 認証
  // ============================================================
  auth: {
    // ドキュメントタイトル（ブラウザタブ表示用）
    documentTitle: {
      login: "ログイン",
      "change-password": "パスワード設定",
      "password-reset": "パスワード再発行のお問い合わせ",
    },
    login: {
      "email-label": "メールアドレス",
      "email-placeholder": "user@example.com",
      "logging-in": "ログイン中...",
      "password-label": "パスワード",
      "password-placeholder": "パスワードを入力してください",
      "submit-button": "ログイン",
      "forgot-password": "パスワードをお忘れの場合",
    },
    messages: {
      "login-failed": "ログインに失敗しました",
      "login-success": "ログインしました",
      "session-expired": "認証が必要です。ログインしてください。",
    },
    "user-menu": {
      "last-login": "最終ログイン日時",
      "logout": "ログアウト",
      "change-password": "パスワード変更",
    },
    "change-password": {
      "dialog-title": "パスワードの変更",
      "current-password-label": "現在のパスワード",
      "current-password-placeholder": "パスワードを入力",
      "new-password-label": "新しいパスワード",
      "new-password-placeholder": "パスワードを入力",
      "new-password-description": "英大文字・英小文字・数字・記号の全てを1文字以上含む、最低8文字以上の文字列",
      "password-label": "パスワード",
      "confirm-password-label": "新しいパスワード（確認用）",
      "confirm-password-mismatch": "パスワードと確認用パスワードが一致しません",
      "success": "パスワードを変更しました",
      "failed": "パスワードの変更に失敗しました",
      "page-title": "パスワードの設定",
      "page-description": "アカウント保護のため、初回ログイン時に新しいパスワードの設定が必要です。使い回しや推測されやすい文字列は避けてください。",
      "submit-button": "設定を完了する",
    },
    "password-reset": {
      "page-title": "パスワード再発行のお問い合わせ",
      "description-1": "システムでの自動再発行機能が準備中のため、現在は事務局にて個別にご本人確認と再発行の手続きを行っております。",
      "description-2": "恐れ入りますが、下記のボタンよりメールソフトを起動し、",
      "description-2-bold": "本文に「ご登録済みのメールアドレス」",
      "description-2-suffix": "をご記入の上、送信してください。",
      "banner-title": "注意事項",
      "banner-item-1": "ご本人確認のため、必ず本文に登録アドレスを正しく記載してください。",
      "banner-item-2": "手続き完了まで、1〜2営業日ほどお時間をいただく場合がございます。",
      "submit-button": "お問い合わせメールを作成する",
      "back-to-login": "ログインに戻る",
    },
  },

  // ============================================================
  // 共通コンポーネント・UI
  // ============================================================
  common: {
    "mailto-note": "※ ボタンを押してもメールソフトが起動しない場合は、以下のアドレスに直接メールをお送りください。",
    actions: {
      cancel: "キャンセル",
      "search-clear": "条件をクリア",
      close: "閉じる",
      "create-new": "新規作成",
      delete: "削除",
      edit: "編集",
      "finish-edit": "編集を終了",
      "go-to-top": "トップページへ",
      retry: "やり直す",
      save: "保存",
      execute: "実行",
      "re-execute": "再実行",
      reload: "リロード",
      "copy": "コピー",
      "csv-export": "CSV出力",
      "csv-exporting": "CSV出力中...",
      "operations-menu": "{name}の操作メニュー",
      "toggle-sidebar": "サイドバーの表示切替",
      "help-center": "サポートサイト",
      "expand-breadcrumbs": "中間パンくずを表示",
    },
    // 共通フィールド名（複数画面で使用されるラベル）
    fields: {
      "accounting-type": "会計区分",
      "amount": "金額",
      "description": "摘要",
      "expenditure-category": "歳出科目（款項目）",
      "fiscal-year": "事業年度",
      "project": "事業",
      "project-overview": "事業概要",
      "recurring-type": "臨時経常区分",
      "status": "ステータス",
    },
    // 共通メッセージ（CRUD操作など）
    messages: {
      "create-success": "{{name}}を作成しました",
      "create-failed": "{{name}}の作成に失敗しました",
      "update-success": "{{name}}を更新しました",
      "update-failed": "{{name}}の更新に失敗しました",
      "delete-success": "{{name}}を削除しました",
      "delete-failed": "{{name}}の削除に失敗しました",
      "delete-confirm-title": "{{name}}の削除",
      "delete-confirm-message": "{{itemName}} を削除しますか？",
      "delete-confirm-warning": "この操作は取り消せません。",
      "execute-confirm-message": "{{itemName}}を実行します。",
      "re-execute-confirm-message": "{{itemName}}を再実行します。",
      "async-job-started-title": "{{jobName}}を開始しました",
      "async-job-started-description": "結果はジョブ管理で確認してください",
      "async-job-failed": "{{name}}の実行に失敗しました",
      "async-job-partial-failure": "一部のスキルの実行に失敗しました",
      "async-job-partial-failure-succeeded": "成功: {{names}}",
      "async-job-partial-failure-failed": "失敗: {{names}}",
      "execute-success": "{{name}}に成功しました",
      "execute-failed": "{{name}}に失敗しました",
      "fetch-failed": "{{name}}の取得に失敗しました",
      "csv-export-success": "CSVを出力しました",
      "csv-export-failed": "CSV出力に失敗しました",
      "search-failed": "検索に失敗しました",
      // データ未登録メッセージ
      "no-data-title": "データが未登録です",
      "upload-instruction-prefix": "から{{dataType}}データをアップロードしてください。{{suffixText}}",
    },
    // 共通セクション名（複数画面で使用されるセクション見出し）
    sections: {
      "basic-info": "基本情報",
    },
    // 共通ステータス
    status: {
      error: "エラーが発生しました",
      failed: "失敗",
      "no-data": "データが見つかりません",
      "no-result": "該当するデータが見つかりません",
      processing: "処理中",
      success: "成功",
    },
    table: {
      "display-settings": "表示設定",
      "no-data": "登録されたデータはありません",
      expand: {
        label: "一括開閉",
        "collapse-all": "すべて折りたたむ",
        "expand-to-project": "節・細節まで展開",
        "expand-all": "すべて展開",
      },
      pagination: {
        "page-size-label": "{{size}}件",
        "page-size-change-error": "ページサイズを変更できませんでした",
        "display-count-label": "表示件数",
      },
    },
    // 共通ドロップゾーン
    dropzone: {
      subtitle: "またはクリックして選択",
    },
    // CSV共通ヘッダー（複数機能のCSV出力で共有）
    "csv-headers": {
      "fiscal-year": "事業年度",
      description: "摘要",
      amount: "金額",
      "recurring-type": "臨時経常区分",
      "funding-type": "単独補助区分",
      "organization-code": "組織コード",
      "organization-name": "組織名称",
      "accounting-type-code": "会計区分コード",
      "accounting-type-name": "会計区分名称",
      "kan-code": "款コード",
      "kan-name": "款名称",
      "ko-code": "項コード",
      "ko-name": "項名称",
      "moku-code": "目コード",
      "moku-name": "目名称",
      "setsu-code": "節コード",
      "setsu-name": "節名称",
      "saisetsu-code": "細節コード",
      "saisetsu-name": "細節名称",
      "saisaisetsu-code": "細々節コード",
      "saisaisetsu-name": "細々節名称",
      "project-code": "事業コード",
      "project-name": "事業名称",
      "project-category1-code": "事業階層1コード",
      "project-category1-name": "事業階層1名称",
      "project-category2-code": "事業階層2コード",
      "project-category2-name": "事業階層2名称",
      "project-category3-code": "事業階層3コード",
      "project-category3-name": "事業階層3名称",
      "settlement-purpose1-code": "決算統計目的コード1",
      "settlement-purpose1-name": "決算統計目的名称1",
      "settlement-purpose2-code": "決算統計目的コード2",
      "settlement-purpose2-name": "決算統計目的名称2",
      "settlement-purpose3-code": "決算統計目的コード3",
      "settlement-purpose3-name": "決算統計目的名称3",
      "settlement-purpose4-code": "決算統計目的コード4",
      "settlement-purpose4-name": "決算統計目的名称4",
      "settlement-nature1-code": "決算統計性質コード1",
      "settlement-nature1-name": "決算統計性質名称1",
      "settlement-nature2-code": "決算統計性質コード2",
      "settlement-nature2-name": "決算統計性質名称2",
      "settlement-nature3-code": "決算統計性質コード3",
      "settlement-nature3-name": "決算統計性質名称3",
      "settlement-nature4-code": "決算統計性質コード4",
      "settlement-nature4-name": "決算統計性質名称4",
      "revenue-source-type": "財源区分",
    },
    unit:{
      label: "単位",
      // 値付きフォーマット（表示用）
      "amount-yen": "{{amount}}円",
      "amount-thousand-yen": "{{amount}}千円",
      "year-with-label": "{{year}}年度",
      // 単位ラベル（単位のみの表示、Input の suffix、トグルボタン等）
      yen: "円",
      "thousand-yen": "千円",
    },
    // フィルター
    filter: {
      "filter-button": "絞り込み",
    },
    // 共通データタイプ名
    "data-types": {
      expenditure: "歳出",
      revenue: "歳入",
      "revenue-appropriation": "財源充当",
    },
  },

  // ============================================================
  // フォーム共通
  // ============================================================
  form: {
    "error-summary": {
      title: "{{total}}件のエラーがあります",
    },
    placeholders: {
      select: "選択してください",
    },
  },

  // ============================================================
  // エラーページ
  // ============================================================
  errors: {
    // ドキュメントタイトル（ブラウザタブ表示用）
    documentTitle: {
      "403": "403",
      "404": "404",
      "500": "500",
    },
    "403": {
      message: "このページへのアクセス権限がありません。",
      "message-detail": "必要な権限がない場合は、管理者にお問い合わせください。",
      title: "403",
    },
    "404": {
      message: "お探しのページは存在しないか、移動された可能性があります。",
      "message-detail": "URLをご確認いただくか、トップページからお探しください。",
      title: "404",
    },
    "500": {
      message: "サーバーでエラーが発生しました。",
      "message-detail": "しばらく時間をおいてから再度お試しください。",
      title: "500",
    },
  },

  // ============================================================
  // AI機能
  // ============================================================
  ai: {
    // チャット
    chat: {
      title: "チャット",
      "welcome-heading": "何でも気軽に聞いてください",
      "welcome-description": "この事業データを元に一緒に考えます",
      "input-placeholder": "この事業の課題を整理して",
      "input-placeholder-welcome": "質問を入力",
      "input-placeholder-thread": "メッセージを入力",
      "send-button": "送信",
      "waiting-response": "AIが回答を生成中...",
      "history-button": "履歴",
      "create-memo-from-thread": "このスレッドを引用してメモを作成",
      "copy-button": "回答をコピー",
      "copy-tooltip": "クリップボードにコピー",
      "copy-failed": "クリップボードへのコピーに失敗しました",
      "reference-info": "事業内容",
      "reference-info-heading": "回答時の事業内容",
      // 事業内チャットの「おすすめの質問」（ITA-2375 で確定した 4 件）
      "suggested-questions": {
        title: "おすすめの質問",
        "q-summary-180": "「住民向け予算公表資料」向けに、この事業の概要を180字でまとめて",
        "q-three-tier-pattern": "この事業の松竹梅パターン（拡充・現状維持・縮小）を提案して",
        "q-kpi": "この事業に適切なKPIを設定するとしたら？",
        "q-budget-validity": "この事業費（要求額）は妥当か？",
      },
    },
    // チャット履歴・お気に入り
    "chat-history": {
      title: "チャット",
      "new-chat": "新しいチャット",
      "section-favorites": "お気に入り",
      "section-recent": "最近",
      "menu-rename": "名前を編集",
      "menu-favorite": "お気に入りに追加",
      "menu-unfavorite": "お気に入りから削除",
      "rename-dialog-title": "チャット名の編集",
      "rename-dialog-placeholder": "チャット名を入力",
      empty: "チャット履歴はありません",
    },
    // 共通
    common: {
      "assistant-title": "AIアシスタント",
      "close-panel": "パネルを閉じる",
    },
    // メニュー
    menu: {
      "under-development-title": "この機能は現在開発中です",
      "under-development-description": "近日リリース予定です。今しばらくお待ちください。",
    },
    // 分析
    analysis: {
      analyzing: "AIが分析中です...",
      completed: "分析が完了しました！",
      "copy-success": "回答をクリップボードにコピーしました",
      executing: "実行中",
      "empty-title": "分析結果がありません",
      "empty-description": "実行すると、この事業に該当する財源の候補をAIが提示します",
      "re-execute-dialog-title": "AI分析の再実行",
      "re-execute-dialog-description": "「{{name}}」の現在の分析結果が上書きされます。",
      "not-supported-title": "お客様の都道府県はまだ対応していません",
      "not-supported-description": "リクエストをいただいた都道府県から、順次対応を進めます。",
      "send-request": "リクエストを送る",
    },
    // エラー
    errors: {
      "analysis-failed-title": "処理に失敗しました",
      "analysis-failed-description": "サーバーまたはネットワークに問題がある可能性があります。数分おいてから再実行してください。",
      "token-limit-exceeded-description": "今月のテナント全体のクレジットを使い切ったため、分析を実行できません。",
      "token-limit-exceeded-button": "プランと使用量を確認",
    },
    // 特別交付税マッチング
    "special-allocation-tax": {
      "link-label": "特別交付税",
      "accordion-title": "特別交付税を探す",
      "accordion-description": "事業内容をもとに、特別交付税の算定基準（省令）と照合し、算入対象となる可能性がある項目を提示します。あわせて、根拠となる条番号・条文・算定式を表示します。",
      title: "この事業で特別交付税を探す",
      description: "事業の目的・内容・費目をもとに、地方交付税（特別交付税）の算入対象となるかを判定します。",
    },
    // 国の補助金等
    "national-grants": {
      "link-label": "国の補助金等",
      "accordion-title": "国の補助金等を探す",
      "accordion-description": "事業内容をもとに、行政事業レビューシートと照合し、活用可能性のある国の補助金・交付金（国庫支出金）を提示します。あわせて、補助金・交付金を活用した類似する他自治体の事業を参考事例として表示します。",
      title: "この事業で国の補助金等を探す",
      description: "事業の目的・内容・費目をもとに、活用可能な国の補助金や交付金があるかを判定します。",
    },
    // 都道府県の補助金等
    "prefectural-grants": {
      "link-label": "都道府県の補助金等",
      "accordion-title": "都道府県の補助金等を探す",
      "accordion-description": "事業内容をもとに活用可能性のある都道府県の補助金・交付金を提示します。",
      title: "この事業で都道府県の補助金等を探す",
      description: "事業の目的・内容・費目をもとに、活用可能な都道府県の補助金や交付金があるかを判定します。",
    },
    // 一括実行
    "bulk-execute": {
      title: "AIスキル一括実行",
      description: "解析に使用する「AIスキル」と、対象の「作成元」を選択してください。",
      "euc-master-label": "対象の作成元",
      "division-label": "組織",
      "skills-label": "AIスキル",
      submit: "一括実行を開始する",
      "analyze-button": "AIで分析",
      // 一括実行用のスキル名（「この事業で」を除いた汎用版）
      "skill-special-allocation-tax": "特別交付税を探す",
      "skill-national-grants": "国の財源を探す",
      "skill-prefectural-grants": "都道府県の財源を探す",
      "skip-analyzed-note": "※解析済みの事業はスキップされるため、重複は発生しません。",
    },
    // PDFアップロード共通（作成・編集で共有）
    "pdf-upload": {
      dropzone: {
        title: "PDFをドラッグ＆ドロップ",
        description: "PDF形式・最大20MB",
      },
      "analyze-button": "PDFを解析して反映",
      "analyzing-message": "{{fileName}}から事業情報を読み取り中",
      "completed-message": "PDFの読み取りが完了しました",
    },
    // PDFから事業を新規作成
    "create-from-pdf": {
      title: "PDFから事業を新規作成",
      description: "事業概要が記載されたPDFをアップロードすると、AIが内容を読み取り、事業情報を自動で反映します。",
      "overwrite-warning": "※ すでに事業概要が入力されている場合、現在の内容はPDFの情報で上書きされます",
    },
    // PDFから事業情報を更新（編集画面）
    "update-from-pdf": {
      title: "PDFから事業情報を更新"
    },
    // AI業務アシスタント（汎用チャット）
    "ai-assistant": {
      "navigation-title": "AI業務アシスタント",
      documentTitle: {
        skills: "おすすめの質問",
        chat: "新しいチャット",
        thread: "チャットスレッド",
      },
      skills: {
        title: "おすすめの質問",
        // ナレッジタグ
        "knowledge-special-tax": "特別交付税",
        "knowledge-national-fund": "補助金・交付金",
        // プロンプト本文（ITA-2374 v1 たたき台）
        "q-special-tax-shelter": "災害時の福祉避難所運営費は特別交付税の措置対象になりますか？",
        "q-ev-grant": "中山間地域での EV 充電拠点整備で使える国の補助金を出典つきで一覧して",
        "q-budget-template": "「住民向け予算公表資料」として事業概要を書くときの型を 180 字程度で教えて",
        "q-public-facility": "公共施設の在り方を検討するときに抜けがちな観点（受益者負担・ライフサイクルコスト・利用実態など）を整理して",
        "q-childcare-planning": "子育て支援の新規事業を立案するときに考慮すべき論点（対象・KPI・財源・リスク）を整理して",
        "q-fertility-rate": "「合計特殊出生率」と「出生数」の違いを、行政資料に書くつもりでやさしく説明して",
      },
      chat: {
        "welcome-heading": "何でも気軽に聞いてください",
        "welcome-description": "ナレッジを選択すると、出典つきで回答できます。",
        "input-placeholder": "質問を入力",
        "add-knowledge": "ナレッジを追加",
        disclaimer: "入力内容は AI の学習に使われません。回答は参考情報のため、最終判断は所定の決裁プロセスで行ってください。",
        "thumbs-up": "回答が役に立った",
        "thumbs-down": "回答が役に立たなかった",
        "thread-menu": "スレッドメニューを開く",
      },
      sidebar: {
        "new-chat": "新規チャット",
        "section-favorites": "お気に入り",
        "section-recent": "最近",
        empty: "チャット履歴はありません",
      },
    },
  },

  // ============================================================
  // サイドパネル離脱確認
  // ============================================================
  "panel-leave-alert": {
    title: "未保存の変更があります",
    description: "保存せずに次の操作へ進みますか？\n入力内容は元に戻せません。",
    confirm: "保存せずに進む",
  },
  "side-panel-leave-alert": {
    title: "読み取り結果は破棄されます",
    description: "この操作を行うと、読み取り結果は破棄されます。\n事業概要はコピー済みですか？",
    confirm: "破棄する",
  },

  // ============================================================
  // 予算編成セクション
  budget: {
    "section-header": "予算編成",
  },

  // 事業（Project）
  // ============================================================
  project: {
    // ナビゲーション
    navigation: {
      title: "事業",
    },

    // ドキュメントタイトル（ブラウザタブ表示用）
    documentTitle: {
      list: "事業一覧",
      create: "事業作成",
      edit: "事業編集",
    },

    // アクション
    actions: {
      "create-from-pdf": "PDFから事業を新規作成",
      "bulk-delete": "削除",
      "clear-selection": "選択解除",
    },

    // ページタイトル
    pages: {
      list: "事業",
      create: "事業の新規作成",
      edit: "事業の編集",
      "search-placeholder": "事業名で検索",
    },

    // フィールド名
    fields: {
      "budget-amount": "予算額",
      "budget-description": "予算概要",
      "budget-division": "組織",
      "project-code": "事業コード",
      "project-description": "事業概要",
      "project-group": "大事業名・中事業名・小事業名",
      "project-name": "事業名",
      source: "作成元",
      "source-import": "取込",
      "source-manual": "手動",
      "source-deleted": "{{name}}（削除済み）",
      tags: "タグ",
      "euc-source": "作成元データ",
    },

    // メッセージ（共通メッセージはcommon.messagesを使用）
    // 例: t('common.messages.create-success', { name: t('project.navigation.title') })
    messages: {
      "no-accounting-types-for-year": "{{year}}年度の会計区分が登録されていません。",
      "no-divisions-for-year": "{{year}}年度の組織が登録されていません。",
      "no-expenditure-categories-for-accounting-type": "選択した会計区分に紐づく歳出科目（款・項・目）が登録されていません。",
      "no-master-data-for-year-description": "で該当年度のデータを登録してください。",
      "empty-title": "事業が登録されていません",
      "empty-description": "取込データを使って一括作成するか、個別に新規作成してください",
      "select-row": "{{name}} を選択",
      "select-all": "全選択",
      "filter-change-confirm-title": "絞り込み条件の変更",
      "filter-change-confirm-message": "絞り込み条件を変更すると、選択中の事業はリセットされます。変更しますか？",
      "bulk-delete-title": "選択中の事業を削除",
      "bulk-delete-warning": "この操作は取り消せません。削除された事業とその関連データ（マッチング結果、チャット履歴など）は完全に削除されます。",
      "bulk-delete-target-label": "削除対象",
      "bulk-delete-success": "{{n}}件の事業を削除しました",
      "bulk-delete-failed": "事業の一括削除に失敗しました",
      "bulk-delete-project-ids-limit": "一括削除できる事業は最大{{max}}件です。選択件数を減らしてください。",
      "bulk-delete-confirm-checkbox": "上記の内容を確認しました",
      "selection-count": "{{n}}件選択中",
    },

    // セクション
    sections: {
      "budget-content": "予算・内容",
      management: "管理",
      "ai-analysis": "AI分析",
    },

    // CSV出力
    "csv-export": {
      "file-name-prefix": "事業一覧",
    },

    // CSVヘッダー（共通項目は common.csv-headers を参照）
    "csv-headers": {
      "fiscal-year": "会計年度",
      "budget-division-code": "予算主管課コード",
      "budget-division-name": "予算主管課名",
      "budget-amount": "予算額",
      tags: "タグ",
      "source-type": "出所",
      "ai-special-allocation-tax": "AI実行結果（特別交付税）",
      "ai-national-grants": "AI実行結果（国の補助金等）",
      "ai-prefectural-grants": "AI実行結果（都道府県の補助金等）",
    },

    // タブ（事業詳細ページ内）
    tabs: {
      detail: "事業詳細",
      memo: "メモ",
    },
  },

  // 事業メモ
  // ============================================================
  "project-memo": {
    documentTitle: {
      memo: "メモ",
    },
    actions: {
      add: "メモを追加",
      save: "保存",
      cancel: "キャンセル",
      edit: "編集",
    },
    fields: {
      body: "本文",
    },
    sections: {
      thread: "スレッド",
    },
    placeholders: {
      body: "本文を入力",
    },
    "empty-list": {
      title: "メモがありません",
      description: "「メモを追加」から作成してください",
    },
    "count-indicator": "{{current}} / {{max}} 件",
    "empty-selection": {
      title: "メモを選択するか、新規に追加してください",
    },
    "thread-link": {
      fallback: "リンク済みスレッド",
      deleted: "削除済みのスレッド",
    },
    draft: {
      title: "（作成中の新規メモ）",
    },
    messages: {
      "create-success": "メモを追加しました",
      "create-failed-max-count": "メモは {{max}} 件までしか追加できません",
      "update-success": "メモを更新しました",
      "update-failed": "メモの更新に失敗しました",
      "delete-success": "メモを削除しました",
    },
  },

  // ============================================================
  // 歳出比較・査定（Assessment）
  // ============================================================
  assessment: {
    // ナビゲーション
    navigation: {
      title: "歳出比較・査定",
    },

    // ドキュメントタイトル（ブラウザタブ表示用）
    documentTitle: {
      list: "歳出比較・査定一覧",
      create: "歳出比較・査定作成",
    },

    // ページタイトル
    pages: {
      create: "歳出比較・査定の新規作成",
      edit: "概要の編集",
    },

    // タブ
    tabs: {
      "yearly-detail": "年度明細",
      diff: "差分",
      overview: "概要",
    },

    // フィールド名
    fields: {
      name: "歳出比較・査定名",
      "name-placeholder": "例：令和7年度 当初予算査定",
      memo: "メモ",
      "memo-placeholder": "例：当初予算2回目査定",
      "base-data": "基準データ（新年度）",
      "compared-data": "比較データ（前年度）",
      "code-name": "コード:名称",
      difference: "差額",
    },

    // メッセージ（共通メッセージはcommon.messagesを使用）
    messages: {
      "ai-empty-title": "AI査定を実行してください",
      "ai-empty-description": "査定を実行すると、ここにAI査定結果が表示されます",
      "ai-result-title": "AI査定結果",
      "go-to-previous": "前の項目へ",
      "go-to-next": "次の項目へ",
      "master-overwrite-warning": "保存すると、選択した取込データをもとに会計区分・款・項・目マスタが自動で作成・上書きされます。",
    },

    // 無効化理由（ツールチップ）
    disabledReasons: {
      "same-as-base": "基準データに選択中のため選択できません",
      "already-registered": "この組み合わせは「{{name}}」で作成済みです",
    },

    // セクションタイトル
    sections: {
      "selection-info": "比較するデータ",
      "selection-description": "各データの歳出データから1つ選択してください",
    },

    // メモアコーディオン
    memo: {
      title: "メモ",
      tag: "タグ",
      placeholder: "メモを入力してください",
    },

    // 比較テーブル
    "comparison-table": {
      "budget-amount": "{{year}} 予算額",
      "accumulation-detail": "{{year}} 積算明細",
      // AI積算明細テーブルのフィールド
      fields: {
        status: "状態",
        name: "名称",
      },
      // AI積算明細テーブルの状態ラベル
      status: {
        increased: "増加",
        decreased: "減少",
        unchanged: "変化なし",
        new: "新規",
        deleted: "削除",
      },
    },

    // アクション
    actions: {
      "execute-ai-bulk-action": "AIで一括査定",
    },

    // CSVヘッダー（共通項目は common.csv-headers を参照）
    "csv-headers": {
      "base-amount": "基準年度金額",
      "compared-amount": "比較年度金額",
      "difference-amount": "差分金額",
      "ai-comment": "AIコメント",
      memo: "メモ",
      "detail-status": "明細状態",
      "base-description": "基準摘要",
      "compared-description": "比較摘要",
      "detail-base-amount": "明細基準金額",
      "detail-compared-amount": "明細比較金額",
      "detail-difference-amount": "明細差分金額",
    },
  },

  // ============================================================
  // データインポート（Data Import）
  // ============================================================
  "data-import": {
    // ナビゲーション
    navigation: {
      title: "データ取込",
    },

    // ドキュメントタイトル（ブラウザタブ表示用）
    documentTitle: {
      list: "データ取込",
      upload: "データアップロード",
      detail: "データ詳細",
    },

    // ページタイトル
    pages: {
      upload: "新しいデータを取込",
      list: "データ取込",
    },

    // アクション
    actions: {
      "execute-import": "取込実行",
      "error-check": "エラーチェック",
      "new-upload": "新規取込",
      "bulk-create-projects": "取込データから事業を一括作成",
      "bulk-create-execute": "一括作成する",
      "download-sample": "サンプルデータ",
      "download-sample-expenditure-2025": "歳出（2025年度）",
      "download-sample-expenditure-2026": "歳出（2026年度）",
    },

    // 空状態
    empty: {
      title: "データがまだ取り込まれていません",
      description: "サンプルデータをダウンロードして、「新規取込」から取り込んでみましょう。\nサンプルデータを加工して、自分の自治体のデータとして使うこともできます。",
    },

    // フィールド名（テーブル・フォーム共通）
    fields: {
      title: "名称",
      "data-type": "データ区分",
      "amount-unit": "アップロードデータ集計単位",
      "amount-unit-yen": "円単位",
      "amount-unit-thousand-yen": "千円単位",
      keyword: "キーワード",
      "keyword-placeholder": "事業階層名称、事業名称、摘要で検索",
      "organization-code": "組織",
      "expenditure-purpose": "歳出科目（款項目）",
      "revenue-nature": "歳入科目",
      "revenue-appropriation-amount": "歳入充当額",
      "revenue-organization": "歳入組織",
      "revenue-category": "歳入科目（款項目節）",
      "revenue-category-detail": "歳入科目（細節以下）",
      "revenue-source-type": "財源区分",
      "expenditure-data": "取込データ（歳出）",
    },

    // テーブル
    table: {
      "import-date": "取込日時",
      "file-name": "ファイル名",
      "settlement-statistics-info": "決算統計に関する実績情報",
      "settlement-statistics-target": "対象",
      "settlement-statistics-hint": "決算統計のコード振り・財源充当処理を開始する際に推論用として利用可能なデータが「対象」と表示されます",
    },

    // フォーム
    form: {
      "upload-info": "アップロード情報",
      "file-upload": "アップロードするファイル",
      description: "補足説明",
      "error-check-result": "エラーチェック結果",
      "warning-check-result": "警告",
      "warning-settlement-statistics": "決算統計コンバーターに関する警告",
      row: "行",
      value: "値",
      "more-items_other": "…他 {{count}} 件",
    },

    // メッセージ
    messages: {
      "upload-failed": "ファイルのアップロードに失敗しました。しばらく待ってから再度お試しください。解消しない場合は管理者にお問い合わせください。",
      "validate-failed": "エラーが検出されました。ファイルを修正して再アップロードしてください。",
      "error-check-success": "エラーチェックが完了しました。取込実行が可能です。",
      "error-check-warning": "エラーチェックが完了しました。警告がありますが、取込実行は可能です。",
      "guardduty-scanning": "ファイルのスキャンに時間がかかっています。しばらく待ってから再度お試しください。",
      "bulk-create-duplicate-warning": "二度同じデータに対して一括作成を実行すると、事業が二重で作成されます。",
      "master-overwrite-warning": "一括作成を実行すると、選択した取込データをもとに会計区分・款・項・目マスタが自動で作成・上書きされます。",
      "select-euc-data-placeholder": "選択してください",
      "no-expenditure-data": "取込データ（歳出）がありません。",
      "no-expenditure-data-instruction-prefix": "事業を一括作成するには、",
      "no-expenditure-data-instruction-suffix": "から歳出データを新規取込してください。",
    },
  },

  // ============================================================
  // 決算統計（Settlement Statistics Converter）
  // ============================================================
  // 決算統計セクション
  "settlement-statistics": {
    "section-header": "決算統計",
  },

  "settlement-statistics-converter": {
    // ナビゲーション
    navigation: {
      title: "決算統計",
      "code-assignment": "コード振り・財源充当",
    },

    // ドキュメントタイトル（ブラウザタブ表示用）
    // {{year}}は年度、{{title}}は処理名称（各ページで設定）
    documentTitle: {
      list: "決算統計コード振り・財源充当結果",
      create: "決算統計 新規処理開始",
      summary: "{{year}} | {{title}} | サマリー",
      analysis: "{{year}} | {{title}} | 分析",
      expenditure: "{{year}} | {{title}} | 歳出コード振り",
      revenue: "{{year}} | {{title}} | 歳入コード振り",
      "revenue-axis-revenue-appropriation": "{{year}} | {{title}} | 財源充当(歳入)",
      master: "{{year}} | {{title}} | マスタ",
    },

    // ページタイトル
    pages: {
      list: "決算統計コード振り・財源充当結果",
      create: "新規処理開始",
      'analysis': "様式照会",
    },

    // 様式照会モード（ドリルスルー）
    "drill-through": {
      "banner-title": "様式照会の集計元データを表示しています。",
      "exit-button": "解除",
    },

    // タブ
    tabs: {
      summary: "サマリー",
      expenditure: "歳出コード振り結果",
      revenue: "歳入コード振り結果",
      "revenue-axis-revenue-appropriation": "財源充当結果",
      master: "マスタ",
    },

    // アクション
    actions: {
      "start-process": "コード振り・財源充当を始める",
    },

    // テーブル
    table: {
      "fiscal-year": "推論対象年度",
      target: "対象",
      "convert-completed-at": "処理開始日時",
    },

    // セクション
    sections: {
      "target-data": "データの選択",
      "inference-data": "1. 推論対象データの選択",
      "training-data": "2. 実績データの選択",
    },

    // フィールド（base/target で同じラベルなので共通化）
    fields: {
      title: "処理名称",
      "fiscal-year": "年度",
      expenditure: "歳出データ",
      revenue: "歳入データ",
      "revenue-appropriation": "財源充当データ",
    },

    "common-fields": {
      organization: "組織",
      "project-category": "事業階層",
      "revenue-category": "歳入科目",
      "settlement-nature": "決算統計性質",
      "settlement-purpose": "決算統計目的",
      "settlement-purpose-revenue": "歳入区分",
    },

    // 金額単位
    "amount-unit": {
      label: "金額単位",
      "truncation-tooltip": "千円単位では端数が切り捨てられます",
    },

    // メッセージ
    messages: {

      "missing-training-data-description": "実績データは列情報が全て入力されている必要があります。",
      "target-data-banner-title": "過去の実績データを元に、AIがコード振り・財源充当の推論を行います。",
      "target-data-banner-description-expenditure": "歳出データを指定すれば、歳出データに対してコード振りの推論が実行されます。",
      "target-data-banner-description-revenue": "歳入データを指定すれば、歳入データに対してコード振りの推論が実行されます。",
      "target-data-banner-description-revenue-appropriation": "財源充当の推論を実行するには、全てのデータを指定する必要があります。",
    },

    // 歳出コード振り結果
    expenditure: {
      // フィールド（検索条件・テーブルカラム共通）
      "expenditure-subsection": "歳出科目（節以下）",
      keyword: "キーワード",
      "keyword-label": "事業階層・事業",
      "funding-type": "単独補助区分",
      // ツールバー
      toolbar: {
        "keyword-placeholder": "キーワードで検索",
      },
      // 編集サイドパネル（メッセージは common.messages.update-success/update-failed を使用）
    },

    // 歳入コード振り結果
    revenue: {
      // フィールド（検索条件・テーブルカラム共通）
      "revenue-source-type": "財源区分",
      // 編集サイドパネル（メッセージは common.messages.update-success/update-failed を使用）
    },

    // マスタ
    master: {
      "expenditure-purpose": "歳出目的マスタ",
      "expenditure-nature": "歳出性質マスタ",
      "revenue-purpose": "歳入区分マスタ",
      level1: "第1分類",
      level2: "第2分類",
      level3: "第3分類",
      level4: "第4分類",
      "create-button": "新規追加",
      "level-code": "第{{level}}分類コード",
      "level-name": "第{{level}}分類名称",
    },

    // 財源充当結果
    "revenue-appropriation": {
      // フィールド（検索条件・テーブルカラム共通）
      "expenditure-amount": "歳出金額",
      "revenue-appropriation-amount": "財源充当額",
      "revenue-total-amount": "収入総額",
      "create-expenditure": "歳出を作成"
    },
    "revenue-axis-revenue-appropriation": {
      "has-appropriation-difference": "充当差額",
      "has-appropriation-difference-true": "差額ありのみ",
    },

    // 分析サイドパネル
    analysis: {
      // テンプレート選択
      "template-select": {
        label: "テンプレート",
        placeholder: "テンプレートを選択",
      },
      // テンプレート選択肢
      "template-options": {
        "revenue-classification": "歳入区分、歳入臨時経常、財源種別ごと決算額",
        "expenditure-purpose-nature": "歳出目的、歳出性質ごと決算額",
        "expenditure-purpose-appropriation": "歳出目的、歳出性質ごと充当額",
        "expenditure-nature-appropriation": "歳出性質ごと充当額",
        "expenditure-nature-recurring-source": "歳出性質、歳出臨時経常、財源種別ごと充当額",
        "expenditure-independent-purpose-nature": "歳出単独、歳出目的、歳出性質ごと決算額",
        "expenditure-subsidy-purpose-nature": "歳出補助、歳出目的、歳出性質ごと決算額",
      },
      // セクション
      sections: {
        "target-data": "対象データ",
        "axis-settings": "軸設定",
        filters: "フィルター",
      },
      // フィールド
      fields: {
        "row-axis": "行軸",
        "column-axis": "列軸",
      },
      // 対象データ選択肢
      "accounting-type-options": {
        expenditure: "歳出",
        revenue: "歳入",
        "revenue-appropriation": "財源充当",
      },
      // 軸選択肢（全会計タイプ共通）
      "axis-options": {
        "expenditure-purpose": "歳出目的",
        "expenditure-nature": "歳出性質",
        "expenditure-recurring-type": "歳出臨時経常",
        "expenditure-funding-type": "歳出単独補助",
        "revenue-purpose": "歳入区分",
        "revenue-recurring-type": "歳入臨時経常",
        "revenue-source-type": "財源区分",
      },
      // フィルターダイアログ
      "filter-dialog": {
        title: "フィルター条件を設定",
        "reset-all": "全てリセット",
        confirm: "設定",
      },
      // フィルターフィールドラベル
      "filter-fields": {
        "accounting-type": "会計区分",
        "expenditure-category": "歳出科目（款項目）",
        "expenditure-subsection": "歳出科目（節以下）",
        "settlement-purpose": "決算統計目的",
        "settlement-nature": "決算統計性質",
        "revenue-category": "歳入科目",
        "revenue-organization": "歳入組織",
        "revenue-settlement-purpose": "歳入決算統計目的",
        "expenditure-funding-type": "単独補助区分",
        keyword: "事業階層・事業",
      },
      // アクション
      actions: {
        apply: "適用",
        "reset-conditions": "条件をリセット",
        add: "追加",
      },
      // フィルター空状態
      "filter-empty": "条件が設定されていません",
      // メインコンテンツ
      "empty-title": "データを選択してください",
      "empty-description": "表示設定から条件を指定して適用すると\n様式が表示されます",
      "no-result-description": "検索条件を変更して再度お試しください",
      "base-amount": "比較元（{{year}}年度）",
      "target-amount": "比較先（{{year}}年度）",
      // 比較表示モード切替
      "comparison-mode": {
        label: "比較表示",
        values: "実数",
        difference: "増減額",
        rate: "増減率",
      },
      // セルポップオーバー: 増減額・増減率ラベル
      "difference-amount": "増減額",
      "rate-label": "増減率",
      "all-increase": "皆増",
      "all-decrease": "皆減",
      // apply-error は common.messages.fetch-failed を使用
      // セルポップオーバーからの遷移ボタン
      "navigate-to-list": {
        expenditure: "歳出コード振り一覧で確認",
        revenue: "歳入コード振り一覧で確認",
        "revenue-appropriation": "財源充当結果一覧で確認",
        // error は common.messages.execute-failed を使用
      },
      // ドリルダウン
      "drill-down": {
        all: "全体",
        "no-classification": "(分類なし)",
        // error は common.messages.execute-failed を使用
      },
    },

    // サマリータブ
    summary: {
      "expenditure-purpose-chart-title": "歳出目的別金額",
      "expenditure-nature-chart-title": "歳出性質別金額",
      "revenue-purpose-chart-title": "歳入区分別金額",
      "cross-table-title": "歳入区分 × 歳出目的",
      "base-amount": "前年度（{{year}}年度）",
      "target-amount": "当年度（{{year}}年度）",
      "ordinary-balance-ratio-title": "経常収支比率",
      "ordinary-balance-ratio-year-on-year": "前年比：",
      "ordinary-balance-ratio-tooltip": "経常収支比率(％) = 経常経費充当一般財源 / 経常一般財源等により算出しています。\n（分母に、減収補填債特例分や臨時財政対策債による収入を含みません。）",
      "ordinary-balance-ratio-no-data": "データなし",
    },

    // CSV出力
    "csv-export": {
      "prefix": "決算統計",
      "revenue-file-name": "歳入コード振り結果",
      "expenditure-file-name": "歳出コード振り結果",
      "revenue-appropriation-file-name": "財源充当結果",
    },

    // 精度確認
    "accuracy-check": {
      // 歳出/歳入で共通のラベル
      "recurring-type-accuracy": "臨時経常区分正解率：",
      expenditure: {
        title: "歳出コード振り精度確認",
        "purpose-accuracy": "決算統計目的正解率：",
        "nature-accuracy": "決算統計性質正解率：",
        "funding-type-accuracy": "単独補助区分正解率：",
      },
      revenue: {
        title: "歳入コード振り精度確認",
        "purpose-accuracy": "歳入区分正解率\u3000\u3000：",
        "source-type-accuracy": "財源区分正解率\u3000\u3000：",
      },
    },

    // 財源充当CSV出力ヘッダー（プレフィックス付きの歳入/歳出区分カラムのみ。共通項目は common.csv-headers を参照）
    "revenue-appropriation-csv-headers": {
      // 歳入側
      "revenue-organization-code": "歳入組織コード",
      "revenue-organization-name": "歳入組織名称",
      "revenue-kan-code": "歳入款コード",
      "revenue-kan-name": "歳入款名称",
      "revenue-ko-code": "歳入項コード",
      "revenue-ko-name": "歳入項名称",
      "revenue-moku-code": "歳入目コード",
      "revenue-moku-name": "歳入目名称",
      "revenue-setsu-code": "歳入節コード",
      "revenue-setsu-name": "歳入節名称",
      "revenue-saisetsu-code": "歳入細節コード",
      "revenue-saisetsu-name": "歳入細節名称",
      "revenue-saisaisetsu-code": "歳入細々節コード",
      "revenue-saisaisetsu-name": "歳入細々節名称",
      "revenue-settlement-purpose1-code": "歳入目的大分類コード",
      "revenue-settlement-purpose1-name": "歳入目的大分類名称",
      "revenue-settlement-purpose2-code": "歳入目的中分類コード",
      "revenue-settlement-purpose2-name": "歳入目的中分類名称",
      "revenue-settlement-purpose3-code": "歳入目的小分類コード",
      "revenue-settlement-purpose3-name": "歳入目的小分類名称",
      "revenue-settlement-purpose4-code": "歳入目的細分類コード",
      "revenue-settlement-purpose4-name": "歳入目的細分類名称",
      "revenue-recurring-type": "歳入臨時経常区分",
      "revenue-source-type": "歳入財源区分",
      "revenue-total-amount": "歳入収入総額",
      "revenue-appropriation-amount": "歳入財源充当額",
      // 歳出側
      "expenditure-kan-code": "歳出款コード",
      "expenditure-kan-name": "歳出款名称",
      "expenditure-ko-code": "歳出項コード",
      "expenditure-ko-name": "歳出項名称",
      "expenditure-moku-code": "歳出目コード",
      "expenditure-moku-name": "歳出目名称",
      "settlement-purpose1-code": "歳出目的大分類コード",
      "settlement-purpose1-name": "歳出目的大分類名称",
      "settlement-purpose2-code": "歳出目的中分類コード",
      "settlement-purpose2-name": "歳出目的中分類名称",
      "settlement-purpose3-code": "歳出目的小分類コード",
      "settlement-purpose3-name": "歳出目的小分類名称",
      "settlement-purpose4-code": "歳出目的細分類コード",
      "settlement-purpose4-name": "歳出目的細分類名称",
      "settlement-nature1-code": "歳出性質大分類コード",
      "settlement-nature1-name": "歳出性質大分類名称",
      "settlement-nature2-code": "歳出性質中分類コード",
      "settlement-nature2-name": "歳出性質中分類名称",
      "settlement-nature3-code": "歳出性質小分類コード",
      "settlement-nature3-name": "歳出性質小分類名称",
      "settlement-nature4-code": "歳出性質細分類コード",
      "settlement-nature4-name": "歳出性質細分類名称",
      "expenditure-recurring-type": "歳出臨時経常区分",
      "expenditure-funding-type": "歳出単独補助区分",
      "expenditure-amount": "歳出金額",
      "expenditure-appropriation-amount": "歳出財源充当額",
    },
  },

  // ============================================================
  // ジョブ管理（Job）
  // ============================================================
  job: {
    // ナビゲーション
    navigation: {
      title: "ジョブ管理",
    },

    // ドキュメントタイトル（ブラウザタブ表示用）
    documentTitle: {
      list: "ジョブ一覧",
      detail: "ジョブ詳細 {{id}}",
    },

    // ページタイトル
    pages: {
      list: "ジョブ管理",
    },

    // セクション
    sections: {
      "error-content": "エラー内容",
    },

    // フィールド
    fields: {
      id: "ジョブID",
      name: "ジョブ名",
      target: "実行対象",
      "start-at": "開始日時",
      "end-at": "終了日時",
      "related-link": "関連画面リンク",
    },

    // 実行対象タイプ
    "target-type": {
      assessments: "歳出比較・査定",
      euc: "データ取込",
      settlement_statistics_converter: "決算統計",
      project_reference_chats: "AI分析",
      project_bulk_create: "事業一括作成",
      project_bulk_reference_chats: "AIスキル一括実行",
    },

    // 操作タイプ
    "operation-type": {
      create: "作成",
      ai_execution: "AI査定",
    },

    // アクション
    actions: {
      "refresh-list": "最新の状態に更新",
    },

    // メッセージ
    messages: {
      "error-occurred": "エラーが発生し、処理を正常に終了できませんでした。",
      "refresh-success": "最新の状態に更新しました",
    },
  },

  // ============================================================
  // プラン＆使用量
  // ============================================================
  "plan-usage": {
    navigation: {
      title: "プラン＆使用量",
    },
    documentTitle: {
      index: "プラン＆使用量",
    },
    pages: {
      title: "プラン＆使用量",
    },
    alert: {
      "limit-reached-title": "AIクレジットが上限に達しました",
      "limit-reached-description": "現在、AI機能をご利用いただけません。\n次回のクレジットリセット（毎月1日）をお待ちいただくか、お急ぎの場合はサポートへお問い合わせください。",
      "low-remaining-title": "クレジット残量が残りわずかです",
      "low-remaining-description-90": "利用率が90%を超えています。ご不明点があればサポートまでお問い合わせください。",
      "low-remaining-description-70": "利用率が70%を超えています。ご不明点があればサポートまでお問い合わせください。",
      // ITA-1502: サポート問い合わせボタンは今後の対応で使用予定
      // "contact-support": "サポートに問い合わせ",
    },
    plan: {
      "free-lite-plan": "無償ライトプラン",
      "free-plan": "無償プラン",
      "paid-plan": "有償プラン",
      "current-plan": "現在のプラン",
      "contract-period": "契約期間",
      "monthly-credit-limit": "月間クレジット上限",
      "credit-unit": "クレジット",
      "contact-paid-plan": "有償プランについて相談する",
    },
    credit: {
      title: "クレジット使用量",
      description: "テナント全体のAIクレジット使用量",
      "usage-format": "{{used}} / {{total}}（{{percentage}}%）",
      "reset-info": "契約日を基準に1ヶ月毎にリセット",
    },
    "token-additions": {
      title: "トークン追加履歴",
      description: "追加トークンは月単位のクレジット消費後に利用され、月を跨いで繰り越されます。",
      fields: {
        "start-date": "追加適用日",
        "total-tokens": "追加トークン",
        "used-tokens": "利用済みトークン",
      },
    },
  },

  // ============================================================
  // マスタ管理
  // ============================================================
  "dat-conversion": {
    navigation: {
      title: "dat変換",
    },
    documentTitle: {
      list: "dat変換",
    },
    dropzone: {
      title: "DATファイルをドラッグ＆ドロップ",
      description: ".dat形式のファイルに対応",
    },
    actions: {
      convert: "変換してダウンロード",
    },
    format: {
      label: "変換先フォーマット",
    },
    formats: {
      "kessantoukei-01-to-22": "決算統計 調査表様式（01表〜22表）",
    },
    errors: {
      "format-not-found": "指定されたフォーマットが見つかりません",
    },
    messages: {
      "convert-success": "Excelファイルの変換が完了しました",
      "convert-failed": "Excelファイルの変換に失敗しました",
    },
  },

  "master-management": {
    navigation: {
      title: "マスタ管理",
    },
    "section-header": "管理",
    documentTitle: {
      "accounting-types": "会計区分",
      "expenditure-items": "歳出科目",
      organizations: "組織",
    },
    menu: {
      "accounting-types": "会計区分",
      "expenditure-items": "歳出科目",
      organizations: "組織",
    },
    // マスタ共通のテーブルカラム（accounting-types/expenditure-items/organizations で共有）
    "common-table": {
      code: "コード",
      name: "名称",
      year: "年度",
    },
    "accounting-types": {
      create: {
        title: "会計区分の新規追加",
        error: {
          "duplicate-code": "同一年度に同一コードが存在します。",
        },
      },
      edit: {
        title: "会計区分の編集",
      },
    },
    "expenditure-items": {
      table: {
        "accounting-type": "会計種別",
      },
      create: {
        title: "歳出科目の新規追加",
        field: {
          level: "種別",
          kan: "款",
          ko: "項",
        },
        level: {
          kan: "款",
          ko: "項",
          moku: "目",
        },
      },
      error: {
        "duplicate-code": "同一階層に同一コードが存在します。",
      },
      edit: {
        title: "歳出科目の編集",
      },
    },
    organizations: {
      create: {
        title: "組織の新規追加",
        error: {
          "duplicate-code": "同一年度に同一コードが存在します。",
        },
      },
      edit: {
        title: "組織の編集",
      },
    },
  },

  // ============================================================
  // タグ
  // ============================================================
  tag: {
    actions: {
      createInline: "新規作成：",
      edit: "タグを編集",
      delete: "タグを削除",
    },
    placeholder: {
      search: "オプションを選択します",
      searchWithCreate: "テキスト入力で、タグの「作成」と「検索」が可能です。",
    },
    messages: {
      createSuccess: "タグを作成しました",
      updateSuccess: "タグを更新しました",
      deleteSuccess: "タグを削除しました",
      assignSuccess: "タグを付与しました",
      unassignSuccess: "タグを解除しました",
      deleteConfirm: "このタグを削除すると、付与済みの紐付けがすべて解除されます",
    },
    validation: {
      required: "タグ名を入力してください",
      maxLength: "タグ名は20文字以内で入力してください",
      duplicate: "同じ名前のタグが既に存在します",
    },
  },

  // ============================================================
  // 確信度（Confidence）
  // ============================================================
  confidence: {
    tooltip: "確信度: {{percentage}}%",
  },

  // ============================================================
  // デバッグメニュー（開発モードのみ）
  // ============================================================
  "debug-menu": {
    "ui-control": "UI制御",
    "release-flag-control": "release-flag制御",
    reset: "デバッグ設定リセット",
    apply: "適用",
    "session-storage-note": "この設定はSessionStorageで管理しています。設定はブラウザタブを閉じるまで保持されます。",
    "empty-mode": {
      label: "以下のデータを空にして表示します。",
      description: "・事業一覧\n・歳出比較・査定一覧/作成\n・ジョブ管理\n・決算統計一覧/作成",
    },
    "accuracy-check-mode": {
      label: "精度確認カードを表示",
      description: "決算統計の歳出/歳入コード振り結果ページに精度確認カードを表示します。\n※推論対象のEUCデータがラベルデータを持つ場合のみ表示されます。",
    },
    "ai-token-error-mode": {
      label: "AIトークンエラーモード",
      description: "ONにすると、AI機能の実行時にトークン制限超過エラー(402)をシミュレートします。\n確認後はOFFに戻してください。\n\n【対象機能】\n・リファレンスチャット（特別交付税/国庫補助金/都道府県補助金）\n・査定AI一括マッピング\n・PDF解析（事業新規作成）",
    },
    "prefectural-grants-override": {
      label: "都道府県補助金マッチング上書き",
      description: "都道府県補助金マッチングの利用可能状態をAPIレスポンスに関わらず上書きします。",
      "option-default": "デフォルト（API準拠）",
      "option-enabled": "有効（強制ON）",
      "option-disabled": "無効（強制OFF）",
    },
    "token-usage-override": {
      label: "トークン使用率オーバーライド",
      description: "ONにすると、プラン＆使用量ページの使用率をスライダーの値で上書きします。バナー表示やProgressBarの色を確認できます。",
    },
    "sticky-note": {
      add: "付箋追加",
      "toggle-visibility": "付箋表示/非表示",
      list: "付箋一覧",
      "list-title": "付箋一覧",
      "no-notes": "付箋がありません",
      navigate: "ページに移動",
      delete: "削除",
      "add-mode-hint": "画面をクリックして付箋を配置（Escでキャンセル）",
    },
  },
}
